export enum NotificationsRoutes {
  root = 'notifications',
}
